/**
 * Created by r4zi4l on 29.07.2022
 */

cleverapps.unitsDemoMode = function () {
    const params = cleverapps.getRequestParameters();
    if (params.unitsDemo === undefined || !cleverapps.config.debugMode) {
        return;
    }

    cleverapps.config.demoMode = true;

    connector.dataLoader.setEnabled(false);
    cleverapps.dataLoader.setEnabled(false);

    AdminEpisodes.prototype.reset = function () {

    };

    Map2dLocation.prototype.loadStaticUnits = function () {
        cleverapps.unitsDemoMode.addUnits(this.map);
    };

    Map2d.prototype.getBackgroundBundle = function () {
        return undefined;
    };

    Map2d.prototype.getTerrainCode = function () {
        return Map2d.TERRAIN_DEMO;
    };

    cleverapps.Plot.onStartup = function (f, returnClassOnly) {
        cleverapps.config.adminMode = true;

        cleverapps.flags.norest = true;
        cleverapps.flags.nologin = true;

        if (returnClassOnly) {
            return cleverapps.meta.getMainScene();
        }

        cleverapps.unitsDemoMode.gotoUnitsDemoScene(f);
    };

    Toolbar.prototype.addItem = function () {};
    SideBar.prototype.addTemporaryIcon = function () {};
    SideBar.prototype.loadAvailable = function () {
        return [];
    };
};

cleverapps.unitsDemoMode.gotoUnitsDemoScene = function (f) {
    const params = cleverapps.getRequestParameters();

    let locationId = params.unitsDemo;
    if (!locationId) {
        locationId = "main";
    }

    if (cleverapps.isNumber(locationId)) {
        locationId = parseInt(locationId);
    }

    if (params.code && Families.codes.includes(params.code) && Families[params.code].expeditions.includes(locationId)) {
        this.unitCode = params.code;
    }

    const locationConfig = cleverapps.meta.getLocationMeta(locationId).locationConfig;

    const originalBundle = bundles[locationConfig.locationBundleId];

    const demoBundle = bundles[locationConfig.locationBundleId] = cleverapps.clone(bundles["location_editor"], true);
    demoBundle.meta.units = originalBundle.meta.units;
    demoBundle.meta.tiles = originalBundle.meta.tiles;
    demoBundle.meta.location = locationId;

    cleverapps.bundleLoader.loadBundle("location_editor", {
        onSuccess: () => {
            cleverapps.meta.switchLocation(locationId);

            cleverapps.meta.gotoLocationScene(f);
        }
    });
};

cleverapps.unitsDemoMode.addUnits = function (map) {
    const getGrounds = function (y1) {
        const ground = [];
        for (let x = 0; x < map.getWidth(); x++) {
            if (map.isGround(x, y1)) {
                ground.push(cc.p(x, y1));
            }
        }
        return ground;
    };

    const rows = [];
    for (let rowInd = 0; rowInd < map.getHeight(); rowInd++) {
        const grounds = getGrounds(rowInd);
        if (grounds.length) {
            rows.push(grounds);
        }
    }

    const groups = cleverapps.unitsDemoMode.getUnitsGroups(map);
    let groupInd = 0;
    let relatedUnits = [];

    const loadNextGroup = function () {
        const nextGroup = groups[groupInd++];
        relatedUnits = relatedUnits.concat(nextGroup.units.slice());
    };

    const isSameType = function () {
        const prevGroup = groups[groupInd - 1];
        const nextGroup = groups[groupInd];
        return nextGroup && nextGroup.type === prevGroup.type;
    };

    const shouldContinueInSameRow = function () {
        const prevGroup = groups[groupInd - 1];
        const nextGroup = groups[groupInd];

        if (!nextGroup) {
            return false;
        }

        const sameRowTypes = [
            ["magicplant", "rubiesplant", "coinsplant", "energyplant"],
            ["energytree", "coinstree"],
            ["unitsshop", "telly", "battlepasspoints", "barrel", "ruins"]
        ];

        return sameRowTypes.some((typeGroup) => typeGroup.includes(prevGroup.type) && typeGroup.includes(nextGroup.type));
    };

    const spawnUnits = function (units, cells, cellsUsedX) {
        const start = Math.floor((cells.length - cellsUsedX) / 2);
        cells = cells.slice(start, start + cellsUsedX);

        units.forEach((unit) => {
            unit.factory(cells[0].x, cells[0].y);
            cells.splice(0, unit.cellsUsedX);
        });
    };

    for (let rowInd = 0; rowInd < rows.length;) {
        while (groupInd < groups.length && (relatedUnits.length === 0 || isSameType() || shouldContinueInSameRow())) {
            loadNextGroup();

            if (shouldContinueInSameRow()) {
                relatedUnits.push({
                    cellsUsedX: 1,
                    cellsUsedY: 1,
                    factory: function () {}
                });
            }
        }

        if (!relatedUnits.length) {
            return;
        }
        
        const row = rows[rowInd];
        const inRowUnits = [];

        const paddingCells = 4;
        let occupiedX = 0, occupiedY = 0;
        while ((row.length - paddingCells) > occupiedX && relatedUnits.length > 0) {
            inRowUnits.push(relatedUnits.shift());
            occupiedX += inRowUnits.at(-1).cellsUsedX;
            occupiedY = Math.max(occupiedY, inRowUnits.at(-1).cellsUsedY);
        }
        spawnUnits(inRowUnits, row, occupiedX);

        rowInd += occupiedY + (relatedUnits.length > 0 ? 0 : 1);
    }

    const remainingGroups = groups.slice(groupInd);
    if (remainingGroups.length) {
        console.error("Remaining groups:", remainingGroups);
        cleverapps.throwAsync("Unable to place all groups in unitsDemo");
    }
};

cleverapps.unitsDemoMode.getUnitsGroups = function (map) {
    const groups = [];

    const codes = this.selectedFamily() ? [this.selectedFamily()] : Families.codes;
    const location = cleverapps.meta.getSelectedLocation();

    if (location.locationConfig.usesWorkers && location.locationConfig.usesWorkers.canWalk) {
        Map2d.currentMap.initWorkers();
    }

    codes.forEach((code) => {
        if (["unknown", "multiCellBody", "thirdelement", "t", "initialize", "landmarkspot", "islanddecoration"].includes(code)) {
            return;
        }
        if (location.families && !location.families[code]) {
            return;
        }

        console.log(`Has ${code}`);

        const family = Families[code];
        const group = {
            code,
            type: family.type,
            layer: Map2d.LAYER_UNITS,
            units: []
        };

        let stages = family.units.length - 1;
        if (family.units[0].mission && !this.selectedFamily()) {
            stages = 0;
        }

        cleverapps.rangeArray(0, stages).forEach((stage) => {
            const unit = new Unit({
                code,
                stage
            });
            unit.chooser = true;

            if (!UnitView.UnitIconFrame(unit) && !UnitView.UnitIconJson(unit)) {
                console.log(`No frame for ${code}_${stage + 1}`);
                return;
            }

            const cellsUsed = {
                x: 1,
                y: 1
            };

            const shape = unit.getShape();

            if (shape.length > 1) {
                const size = shape.reduce((total, current) => {
                    total.x = total.x < current.x + 1 ? current.x + 1 : total.x;
                    total.y = total.y < current.y + 1 ? current.y + 1 : total.y;
                    return total;
                }, { x: 1, y: 1 });
                cellsUsed.x = size.x + 1;
                cellsUsed.y = size.y + 1;
            }

            if (this.selectedFamily()) {
                cellsUsed.x += 1;
                cellsUsed.y += 1;
            }

            group.units.push({
                cellsUsedX: cellsUsed.x,
                cellsUsedY: cellsUsed.y,
                factory: function (x, y) {
                    unit.setPosition(x, y);
                    map.add(Map2d.LAYER_UNITS, x, y, unit);
                    return unit;
                }
            });
        });

        groups.push(group);
    });

    return groups;
};

cleverapps.unitsDemoMode.selectedFamily = function () {
    return this.unitCode;
};

cleverapps.unitsDemoMode.isSelectedUnit = function (unit) {
    if (!this.selectedUnit || !unit) {
        return;
    }
    return this.selectedUnit.code === unit.code && this.selectedUnit.stage === unit.stage;
};

cleverapps.unitsDemoMode.selectUnit = function (unit) {
    this.selectedUnit = unit;
    this.selectedUnit.highlight && this.selectedUnit.highlight({ drag: true });
};

cleverapps.unitsDemoMode.clearSelectUnit = function () {
    if (this.selectedUnit) {
        this.selectedUnit.unhighlight && this.selectedUnit.unhighlight();
    }
    this.selectedUnit = undefined;
};